import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiArrowRight, FiAlertCircle } = FiIcons;

const PasswordGate = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Logo URL with raw=1
  const logoUrl = "https://www.dropbox.com/scl/fi/m1e6agmnwiz92uid4bx3y/Gyso-Call-Logo.png?rlkey=encbf5fh2ngjiiaqwtploq2ec&st=4fwrw1vl&raw=1";

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) return;

    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/auth/check-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (data.ok) {
        // Set session flag
        sessionStorage.setItem('gyso_admin_authed', '1');
        // Notify parent
        onLogin();
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
    } catch (err) {
      setError('Connection error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-90 backdrop-blur-sm px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-2xl overflow-hidden transform transition-all">
        <div className="p-8">
          <div className="flex justify-center mb-6">
            <img className="h-16 w-auto" src={logoUrl} alt="Gyso Call" />
          </div>
          
          <div className="flex justify-center mb-6">
            <div className="p-3 bg-blue-100 rounded-full">
              <SafeIcon icon={FiLock} className="w-8 h-8 text-blue-600" />
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-2">
            Restricted Access
          </h2>
          <p className="text-center text-gray-500 mb-8">
            Please enter the admin password to continue.
          </p>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label htmlFor="password" class="sr-only">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full px-4 py-3 text-gray-900 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 placeholder-gray-400 transition-colors"
                placeholder="Enter admin password"
                autoFocus
                disabled={loading}
              />
            </div>

            {error && (
              <div className="flex items-center p-3 text-sm text-red-700 bg-red-50 rounded-lg animate-pulse">
                <SafeIcon icon={FiAlertCircle} className="flex-shrink-0 mr-2" />
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !password}
              className="w-full flex justify-center items-center px-4 py-3 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              {loading ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Verifying...
                </span>
              ) : (
                <span className="flex items-center">
                  Enter Application <SafeIcon icon={FiArrowRight} className="ml-2" />
                </span>
              )}
            </button>
          </form>
        </div>
        <div className="bg-gray-50 px-8 py-4 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-500 uppercase tracking-wide font-semibold">
            Secure Admin Area
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;